import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import TopBanner from "../../../components/topBanner/topBanner";
import imgBaner from "../../../images/banner/banner---gioi-thieu.png";
import TitleCenter from "../../../components/title/TitleCenter";
import NewsCategory from "./NewsCategory";
import { normalizeLang } from "../../../utils/localeDataLoader";
import { getNewsCategoriesByLanguage } from "../../../apis/newsCategories";
import { getNewsByLanguage } from "../../../apis/news";

function News() {
  const { t, i18n } = useTranslation();
  const [newsCategories, setNewsCategories] = useState([]);
  const [newsItems, setNewsItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const languageCode = normalizeLang(i18n.language);
    const expectedPath = languageCode === "en" ? "/news" : "/tin-tuc";
    const cleanPath = location.pathname.replace(/\/$/, "");

    if (
      cleanPath !== expectedPath &&
      (cleanPath === "/news" || cleanPath === "/tin-tuc")
    ) {
      navigate(expectedPath, { replace: true });
    }
  }, [i18n.language, location.pathname, navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const languageCode = normalizeLang(i18n.language);
        const [categories, items] = await Promise.all([
          getNewsCategoriesByLanguage(languageCode),
          getNewsByLanguage(languageCode),
        ]);

        if (!cancelled) {
          setNewsCategories(categories);
          setNewsItems(items);
        }
      } catch (error) {
        console.error("Failed to load news", error);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [i18n.language]);

  return (
    <div className="news_controller">
      <TopBanner
        titleCenter={t("news.news")}
        imgBanner={imgBaner}
        pageName={t("pages.news")}
      />
      <main className="layout_container news-editorial">
        {newsCategories.map((category) => (
          <section className="news-editorial__category" key={category.id}>
            <TitleCenter text={category.title} />
            <NewsCategory categoryID={category.id} newsItems={newsItems} />
          </section>
        ))}
      </main>
    </div>
  );
}

export default News;